<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui'
import type { RefreshToken } from '@/lib/charts/timeRange'
import { computed } from 'vue'

const props = defineProps<{
  modelValue: RefreshToken
  loading?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [RefreshToken]
  'refresh': []
}>()

const options: RefreshToken[] = ['off', '10s', '30s', '1m', '5m']

const items = computed<DropdownMenuItem[]>(() =>
  options.map(option => ({
    label: option === 'off' ? 'Off' : option,
    icon: props.modelValue === option ? 'i-lucide-check' : undefined,
    onSelect: () => emit('update:modelValue', option),
  })),
)

const intervalLabel = computed(() => (props.modelValue === 'off' ? '' : props.modelValue))
</script>

<template>
  <UFieldGroup>
    <UButton
      icon="i-lucide-refresh-cw"
      color="neutral"
      variant="subtle"
      :loading="loading"
      aria-label="Refresh now"
      @click="emit('refresh')"
    />
    <UDropdownMenu :items="items">
      <UButton
        color="neutral"
        variant="subtle"
        :label="intervalLabel"
        icon="i-lucide-timer"
        trailing-icon="i-lucide-chevron-down"
      />
    </UDropdownMenu>
  </UFieldGroup>
</template>
